import { render, staticRenderFns } from "./UyapEngelSeridi.vue?vue&type=template&id=244dad34"
import script from "./UyapEngelSeridi.vue?vue&type=script&lang=ts"
export * from "./UyapEngelSeridi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports